import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { useApiClient } from '../../../../../lib/apiClient';
import { throwInfo } from '../../../../../redux/modules/messages/actions';
import { HOOK_INTERFACES_QUERY_KEY } from '../../../../extension-interop/hooks/useHookInterfaces';
import { QUERY_KEY_HOOKS } from '../../../hooks/useHooks';

export const useCreateStoreHook = () => {
  const dispatch = useDispatch();
  const api = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const storeHook = await api.request(
        endpoints.hooks.create({
          type: 'webhook',
          name: 'External store from Git',
          settings: {},
          queues: [],
          events: ['invocation.interface'],
          config: {
            url: 'WEBHOOK URL',
          },
          extensionSource: 'custom',
        })
      );

      await api.request(
        endpoints.hookInterfaces.create({
          type: 'store',
          hook: storeHook.url,
          metadata: {},
          payload: {},
          name: 'External store from Git',
          description: 'Fetch extensions from a Git repository',
        })
      );

      await api.request(
        endpoints.hookInterfaces.create({
          type: 'command',
          hook: storeHook.url,
          metadata: {},
          payload: { command: 'add_repository' },
          name: 'Set external store repository',
          description: '',
        })
      );

      return storeHook;
    },

    onSuccess: () => {
      dispatch(throwInfo('extensionCreated'));
      queryClient.invalidateQueries([QUERY_KEY_HOOKS]);
      queryClient.invalidateQueries([HOOK_INTERFACES_QUERY_KEY]);
    },
  });
};
